import {apiMaster} from "./ApiMaster";  

export async function labelsL2Get (data) {
    data.authO.loading = true;

    // data.authO.selectedLang
    let requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
            "surveyBot": data.authO.projectId,
            "userId": data.authO.userUuid,
            "language": data.authO.selectedLang 
        })
    };

    let resp = await apiMaster(
        data,
        `${data.authO.uri_prosper_mn}/api/labels/l2`, 
        requestOptions
    );

    return resp;
}
